import * as yup from 'yup';
import { minZeroMsg, requiredMsg } from '../../utils/validationMessages';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import {
  conversionRatioField,
  integerField,
  usdField,
} from '../../../../../../../schemas/common-schema-defs';

export function noteSafeConversionFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema().required(requiredMsg('Transaction Date')),
    convertedPrincipalAmount: usdField()
      .required(requiredMsg('Converted Principal'))
      .min(0, minZeroMsg('Converted Principal')),
    convertedSharesNo: integerField()
      .required(requiredMsg('Number of Converted Shares'))
      .min(0, minZeroMsg('Number of Converted Shares')),
    currencyid: transactionCurrencyIdField(),
    fullyDilutedShares: integerField().nullable().optional(),
    notes: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
    security: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
    conversionRatio: conversionRatioField(),
  };
}

export function noteSafeConversionFormSchema() {
  return yup.object().shape(noteSafeConversionFields());
}

export function noteSafeConversionGridSchema() {
  return yup.object().shape(noteSafeConversionFields()).omit(['fullyDilutedShares']);
}
